module.exports = __webpack_public_path__ + "static/media/UnderlineBlack.9808b454.svg";